import React from 'react';
import Ola from './detalle-ola';
import CargaManual from './detalle-carga-manual';
import AllSeasons from './detalle-allseasons';
import Eurovips from './detalle-eurovips';
import Amichi from './detalle-amichi';
// import Pythagoras from './detalle-pythagoras';
import JuliaTours from './detalle-julia-tours';

const PaqueteRouter = (props) => {
  const proveedores = {
    1: (<CargaManual {...props} />),
    2: (<Ola {...props} />),
    3: (<AllSeasons {...props} />),
    4: (<Eurovips {...props} />),
    5: (<CargaManual {...props} />), // Pythagoras
    6: (<CargaManual {...props} />), // Pythagoras
    7: (<CargaManual {...props} />), // Pythagoras
    8: (<CargaManual {...props} />), // Pythagoras
    9: (<CargaManual {...props} />), // Pythagoras
    10: (<Amichi {...props} />),
    11: (<CargaManual {...props} />), // Pythagoras
    12: (<JuliaTours {...props} />),
    13: (<CargaManual {...props} />),
  };

  return (
    <div>
      {proveedores[parseInt(props.proveedorId, 10)]}
    </div>
  );
};

export default PaqueteRouter;
